import axios from 'axios'
import store from '@/store'
import { showNotification, goLogin } from '@/utils'
import { setToken } from '@/utils/cookies'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// create an axios instance
const service = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_BASE_URL : window.location.origin,
  withCredentials: false,
  timeout: 2 * 60 * 1000
})

// request interceptor
service.interceptors.request.use(config => {
  // Token
  if (store.getters.token) {
    config.headers['tc-token'] = store.getters.token
  }
  // Team Token
  if (store.getters.teamToken) {
    config.headers['tc-team-token'] = store.getters.teamToken
  }
  // 多语言
  if (store.getters.language) {
    config.headers['Accept-Language'] = store.getters.language
  }
  // 杜绝浏览器缓存问题
  if (Object.prototype.hasOwnProperty.call(config, 'params') && config['params']) {
    config['params']['t'] = new Date().getTime()
  } else {
    config['params'] = {
      't': new Date().getTime()
    }
  }

  return config
}, error => {
  showNotification('error', error.message)
  return Promise.reject(error)
})

service.interceptors.response.use(
  response => {
    if (response.status !== 200) {
      showNotification('error', response.statusText)
      return Promise.reject(new Error(response.statusText || 'Error'))
    }

    // 更新Token
    if (response.headers['new-tc-token']) {
      store.dispatch('user/setToken', response.headers['new-tc-token'])
      setToken(response.headers['new-tc-token'])
    }

    const res = response.data

    switch (res?.error_code) {
      case 'ERROR_USER_NOT_EXISTS': // 用户不存在
      case 'ERROR_USER_NOT_LOGIN': // 用户未登录
      case 'ERROR_USER_LOCKED': // 用户被锁定
        goLogin()
        break
      case 'OK': // 成功的请求
        return res
      default: // 其它错误
        break
    }

    showNotification('error', res?.msg)
    return Promise.reject(new Error(res?.msg || 'Error'))
  },
  error => {
    showNotification('error', error.message)
    return Promise.reject(error)
  }
)

export default service
